export default article => {
  const { article_heading, author, body_copy_1 } = article;
  return [
    {
      type: "application/ld+json",
      innerHTML: `{
      "@context": "https://schema.org",
      "@type": "Journal",
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "${window.location.href}"
      },
      "headline": "${article_heading}",
      "author": {
        "@type": "Person",
        "name": "${author}"
      },
        "publisher": {
        "@type": "Organization",
        "name": "Guinness Open Gate Brewery"
      },
      "description": "${body_copy_1}"
      }`
    }
  ];
};



// WEBPACK FOOTER //
// ./src/components/organisms/Article/meta.js